import React from 'react';

import { Modal, LoadingSpinner } from '@marketmuse/components';
import { miscActions } from '@marketmuse/data-state/misc';
import { MISC_SIMPLE_KEYS } from '@marketmuse/data-state/types';
import { useStoreDispatch } from '@marketmuse/data-state/hooks';

const hubspotPortalId = process.env.REACT_APP_HUBSPOT_PORTAL_ID;

const HubspotModal = () => {
  const dispatch = useStoreDispatch();

  if (!hubspotPortalId) {
    console.error(
      'HubspotModal: REACT_APP_HUBSPOT_PORTAL_ID environment variable is not set. Please configure this variable to enable the HubSpot modal.',
    );
    return null;
  }

  return (
    <Modal
      panelWrapperClassName={'p-2'}
      panelClassName={['max-w-4xl', 'overflow-y-auto', 'max-h-full']}
      isVisible={true}
      onClose={() => {
        dispatch(
          miscActions.setSimple({
            key: MISC_SIMPLE_KEYS.salesUpsellMotion,
            value: false,
          }),
        );
      }}
    >
      <div
        className="hs-form-frame"
        data-region="eu1"
        data-form-id="9cd202a8-3348-4d10-af78-9ac6e89cf50e"
        data-portal-id={hubspotPortalId}
      >
        <LoadingSpinner className="m-auto" />
      </div>
    </Modal>
  );
};

export default HubspotModal;
